/* Copyright 2013 - 2024 Waiterio LLC */
import window from './window.js'

const standalone =
  window?.navigator?.standalone ||
  window?.matchMedia?.('(display-mode: standalone)')?.matches ||
  false

export default standalone
